export function cn(...inputs: (string | undefined)[]) {
  return inputs.filter((s) => Boolean(s?.trim())).join(' ');
}
